"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuildSettings = void 0;
var credits_1 = require("./credits");
var settingsElement = document.querySelector("#settings");
document.querySelector("#settings-close-button").addEventListener("click", function () {
    settingsElement.style.display = "none";
});
document.querySelector("#settings-open-button").addEventListener("click", function () {
    settingsElement.style.display = "flex";
});
var BuildSettings = function () {
    var creditsElement = document.querySelector("#credits");
    creditsElement.innerHTML = (0, credits_1.GetCredits)();
};
exports.BuildSettings = BuildSettings;
